import { formatAmountCompact as formatAmountCompactRaw, formatMajorAmount as formatMajorAmountRaw, formatMinorAmount as formatMinorAmountRaw, formatPriceDifference as formatPriceDifferenceRaw, isOperatingCurrencyCode, } from '@owner/currency';
const currencyOptions = (cfg, options) => ({
    ...options,
    bcpTag: cfg.locale,
    currency: cfg.currency,
});
export const formatMajorAmount = (amount, cfg, options) => formatMajorAmountRaw(amount, currencyOptions(cfg, options));
export const formatMinorAmount = (amount, cfg, options) => formatMinorAmountRaw(amount, currencyOptions(cfg, options));
export const normalizeOperatingCurrencyCode = (currency) => {
    if (typeof currency !== 'string')
        return undefined;
    const normalizedCurrency = currency.trim().toUpperCase();
    return isOperatingCurrencyCode(normalizedCurrency)
        ? normalizedCurrency
        : undefined;
};
export const formatMinorAmountForCurrency = (amount, currency, cfg, options) => {
    const normalizedCurrency = normalizeOperatingCurrencyCode(currency);
    if (normalizedCurrency == null) {
        return formatMinorAmountRaw(amount, currencyOptions(cfg, { ...options, includeSymbol: false }));
    }
    return formatMinorAmountRaw(amount, currencyOptions({ ...cfg, currency: normalizedCurrency }, options));
};
export const formatAmountCompact = (amount, cfg, options) => formatAmountCompactRaw(amount, currencyOptions(cfg, options));
export const formatPriceDifference = (amount, cfg, options) => formatPriceDifferenceRaw(amount, currencyOptions(cfg, options));
//# sourceMappingURL=formatAmount.js.map